<script lang="ts">
  import { invalidateAll } from '$app/navigation';
  import { updateCourse } from '$lib/api/courses';
  import CourseEditor from '$lib/components/courses/CourseEditor.svelte';
  import type { PageProps } from './$types';

  let { params, data }: PageProps = $props();
</script>

{#await data.coursePromise then course}
  <div class="py-4">
    <CourseEditor
      onSave={async course => {
        await updateCourse(parseInt(params.id), course);
        invalidateAll();
      }}
      {course}
    />
  </div>
{/await}
